const clients = [
  {
    id: 11,
    system: "VENTURUS",
    module: "ZNAP_SECURITY",
    modulePath: "",
    moduleName: "portal",
    language: "pt",
    port: 8080,
    theme: "venturus.js",
    env: "hml-new-netsuite",
  },
];

const getClientConfigs = (clientId) =>
  clients.find((client) => client.id === clientId);
const configs = getClientConfigs(11);

export default {
  ...configs,
};
